export const EmailValidation = (inputName: string, value: string): CoreValidatorResult => {

    return { valid: true, error: "e-mail is not valid" };
}
export const Expressions = {
    EMAIL: /\S+@\S+\.\S+/,

    // ^                         Start anchor
    // (?=.*[A-Z].*[A-Z])        Ensure string has two uppercase letters.
    // (?=.*[!@#$&*])            Ensure string has one special case letter.
    // (?=.*[0-9].*[0-9])        Ensure string has two digits.
    // (?=.*[a-z].*[a-z].*[a-z]) Ensure string has three lowercase letters.
    // .{8}                      Ensure string is of length 8.
    // $ 
    STRONG_PASSWORD: /^(?=.*[A-Z])(?=.*[!@#$&*])(?=.*[0-9])(?=.*[a-z].*[a-z].*[a-z]).{6,}$/
}
export const RequiredValidation = (inputName: string, value: string): CoreValidatorResult => {
    if (!!value) {
        return { valid: true };
    } else {
        return { valid: false, error: "Este campo é obrigatório" };

    }
}

export const MaxLength = (max: number): CoreValidatorFunction => {
    return (name: string, value: string): CoreValidatorResult => {
        if (!value)
            return { valid: true };
        else {
            if (value.length > max)
                return { valid: false, error: `Este campo ultrapassou o limite de caracteres (${max})` }
            else
                return { valid: true };
        }
    }
}


export const MatchValidation = (matchValue: string, error: string): CoreValidatorFunction => {
    return (name: string, value: string): CoreValidatorResult => {
        console.log("MatchValidation", { matchValue, value });
        if (value == matchValue) return { valid: true };
        else return { valid: false, error }
    }
}

export const RegexValidation = (regex: RegExp, error: string) => {

    return (inputName: string, value: string): CoreValidatorResult => {
        if (!value) return { valid: false, error };
        if (value.match(regex))
            return { valid: true };
        else
            return { valid: false, error };
    }
}


export type CoreValidatorFunction = (name: string, value: string) => CoreValidatorResult;